<template>
    <v-container fluid style="max-width: 720px">
        <v-row class="align-center mb-2">
            <v-col cols="auto">
                <h2 class="text-h6">Notifiche</h2>
            </v-col>
            <v-spacer />
            <v-col cols="auto" v-if="nonLette > 0">
                <v-btn variant="text" size="small" @click="segnaTutteLette">Segna tutte come lette</v-btn>
            </v-col>
        </v-row>

        <div v-if="lista.length === 0" class="text-center text-medium-emphasis pa-8">
            Nessuna notifica.
        </div>

        <v-card v-for="n in lista" :key="n.id" variant="outlined" class="mb-2 rounded-lg"
            :class="{ 'bg-blue-lighten-5': !n.letta }" style="cursor: pointer" @click="apri(n)">
            <v-card-text class="d-flex align-start" style="gap: 12px">
                <v-icon :color="n.letta ? 'grey' : 'primary'" class="mt-1">
                    {{ n.letta ? 'mdi-email-open-outline' : 'mdi-email' }}
                </v-icon>
                <div class="flex-grow-1">
                    <div class="d-flex align-center" style="gap: 8px">
                        <span class="font-weight-medium">{{ n.titolo }}</span>
                        <v-chip v-if="n.categoria" size="x-small" variant="tonal">{{ n.categoria }}</v-chip>
                    </div>
                    <div class="text-body-2 text-medium-emphasis">{{ n.messaggio }}</div>
                    <div class="text-caption text-medium-emphasis mt-1">{{ formattaData(n.dataCreazione) }}</div>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: "NotifichePage",

    computed: {
        lista() {
            return this.$store.getters["notifiche/lista"];
        },
        nonLette() {
            return this.$store.getters["notifiche/nonLette"];
        },
    },

    mounted() {
        this.$store.dispatch("notifiche/carica");
        this.$store.dispatch("notifiche/caricaConteggio");
    },

    methods: {
        formattaData(iso) {
            return new Date(iso).toLocaleString("it-IT", {
                day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit",
            });
        },

        async apri(n) {
            if (!n.letta) {
                try {
                    await this.$store.dispatch("notifiche/segnaLetta", n.id);
                } catch (error) {
                    console.log(error);
                }
            }
            if (n.link) this.$router.push({ path: n.link });
        },

        async segnaTutteLette() {
            try {
                await this.$store.dispatch("notifiche/segnaTutteLette");
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
